import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, formDataPost, get, patch, post, put } from "helpers/api_helper"
import {
  ADD_CANDIDATE_IN_INTERVIEW,
  ASSESSMENT_LIST,
  CHANGE_JOB_TITLE,
  CREATE_INTERVIEW_SCHEDULE,
  DELETE_INTERVIEW_APPOINTMENT_CANDIDATE,
  GET_ASSESSMENT_DETAILS,
  GET_INTERVIEW_APPOINTMENT_CANDIDATES,
  GET_INTERVIEW_QUESTIONS,
  GET_INTERVIEW_SCHEDULE_DETAILS,
  GET_INTERVIEW_SCHEDULE_LIST,
  GET_MATCHED_CANDIDATES_LIST,
  INVITED_CANDIDATE_IMPORT,
  SUBMIT_INTERVIEW_ASSESSMENT,
  UPDATE_INTERVIEW_SCHEDULE,
} from "helpers/url_helper"

export const getInterviewsScheduleList = createAsyncThunk(
  GET_INTERVIEW_SCHEDULE_LIST,
  async payload => {
    const response = await post(GET_INTERVIEW_SCHEDULE_LIST, payload)
    return response
  }
)

export const createInterviewSchedule = createAsyncThunk(
  CREATE_INTERVIEW_SCHEDULE,
  async payload => {
    const response = await post(CREATE_INTERVIEW_SCHEDULE, payload)
    return response
  }
)

export const updateInterviewSchedule = createAsyncThunk(
  UPDATE_INTERVIEW_SCHEDULE,
  async data => {
    const { uuid, payload } = data
    const response = await put(`${UPDATE_INTERVIEW_SCHEDULE}/${uuid}`, payload)
    return response
  }
)

export const getInterviewScheduleDetails = createAsyncThunk(
  GET_INTERVIEW_SCHEDULE_DETAILS,
  async id => {
    const response = await get(`${GET_INTERVIEW_SCHEDULE_DETAILS}/${id}`)
    return response
  }
)

export const getMatchedCandidatesList = createAsyncThunk(
  GET_MATCHED_CANDIDATES_LIST,
  async payload => {
    const response = await post(GET_MATCHED_CANDIDATES_LIST, payload)
    return response
  }
)

export const getAssessmentList = createAsyncThunk(
  ASSESSMENT_LIST,
  async payload => {
    const response = await post(ASSESSMENT_LIST, payload)
    return response
  }
)

export const getInterviewQuestions = createAsyncThunk(
  GET_INTERVIEW_QUESTIONS,
  async () => {
    const response = await get(GET_INTERVIEW_QUESTIONS)
    return response
  }
)

export const getAssessmentDetails = createAsyncThunk(
  GET_ASSESSMENT_DETAILS,
  async uuid => {
    const response = await get(`${GET_ASSESSMENT_DETAILS}/${uuid}`)
    return response
  }
)

export const submitInterviewAssessment = createAsyncThunk(
  SUBMIT_INTERVIEW_ASSESSMENT,
  async data => {
    const { uuid, payload } = data
    const response = await post(
      `${SUBMIT_INTERVIEW_ASSESSMENT}/${uuid}`,
      payload
    )
    return response
  }
)

export const changeJobTitle = createAsyncThunk(
  CHANGE_JOB_TITLE,
  async payload => {
    const response = await post(CHANGE_JOB_TITLE, payload)
    return response
  }
)

export const getInterviewAppointmentCandidates = createAsyncThunk(
  GET_INTERVIEW_APPOINTMENT_CANDIDATES,
  async payload => {
    const response = await post(GET_INTERVIEW_APPOINTMENT_CANDIDATES, payload)
    return response
  }
)

export const getInterviewsAppointmentInvitedUser = createAsyncThunk(
  GET_INTERVIEW_APPOINTMENT_CANDIDATES + "APPOINTMENT_INVITED_USER",
  async payload => {
    const response = await post(GET_INTERVIEW_APPOINTMENT_CANDIDATES, payload)
    return response
  }
)

export const deleteInterviewAppointmentCandidate = createAsyncThunk(
  DELETE_INTERVIEW_APPOINTMENT_CANDIDATE + "DELETE",
  async id => {
    const response = await del(
      `${DELETE_INTERVIEW_APPOINTMENT_CANDIDATE}/${id}`
    )
    return response
  }
)

export const addCandidateInInterview = createAsyncThunk(
  ADD_CANDIDATE_IN_INTERVIEW,
  async payload => {
    const response = await post(ADD_CANDIDATE_IN_INTERVIEW, payload)
    return response
  }
)

export const addCandidateViaFileInInterview = createAsyncThunk(
  INVITED_CANDIDATE_IMPORT,
  async payload => {
    const response = await formDataPost(INVITED_CANDIDATE_IMPORT, payload)
    return response
  }
)
